((drupalSettings) => {
  const root = document.querySelector(".hp-rs");
  const data = drupalSettings.yellowstone.socialWall;
  const list = root.querySelector(".hp-rs__list");

  const createList = () => {
    const dataFb = data.villemomble_fb;
    const dataInsta = data.instagram_de_villemomble;
    const dataYt = data.youtube_de_villemomble;

    const arrayInOrder = [
      dataFb[0],
      dataYt[0],
      dataInsta[0],
      dataInsta[1],
      dataFb[1],
      dataInsta[2],
    ];

    arrayInOrder.forEach((item) => {
      list.insertAdjacentHTML("beforeend", item);
    });
  };

  // callback is called on intersection change
  const onIntersection = (entries, opts) => {
    entries.forEach((entry) =>
      entry.target.classList.toggle("visible", entry.isIntersecting)
    );
  };

  const seeScroll = () => {
    let observer = new IntersectionObserver(onIntersection, {
      root: null, // default is the viewport
      threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
    });

    observer.observe(root);
    // observer.unobserve(entry.target);
  };

  const init = () => {
    createList();
    seeScroll();
  };

  init();
})(drupalSettings);
